module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue6.ace8940a.jpg";